
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.375 4.688H5.625a.937.937 0 00-.938.937v18.75c0 .518.42.938.938.938h18.75c.518 0 .938-.42.938-.938V5.625a.937.937 0 00-.938-.938zM14.063 13.125v7.5M10.313 13.125v7.5","stroke":"#000C1F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.063 16.406a3.28 3.28 0 116.562 0v4.219","stroke":"#000C1F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.313 10.781a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812z","fill":"#000C1F"}})])
          )
        }
      }
    